export const environment = {
  production: false,
  oidc: {
    authority: 'https://sso-dev.mhsolutions.pl',
    clientId: 'mhs-manager-staging',
    redirectUrl: 'https://manager-dev-next.mhsolutions.pl/login-oidc',
    postLogoutRedirectUri: 'https://manager-dev-next.mhsolutions.pl/logout-oidc',
  },
  internalApiUrl: 'https://internal-api-dev.mhsolutions.pl',
  gatewayUrl: 'https://api-dev.mhsolutions.pl',
};
